import { useUpdateTasks } from 'features/tasks';
import React from 'react';
import { PopupMenu } from 'shared/components/ui/popup-menu';
import { PriorityPickerMenu } from 'shared/components/ui/priority-picker-menu';
import { Task } from 'shared/types/task';
import { TaskPriorityOptions } from 'shared/types/task-base';

export type PrioritySubMenuProps = Omit<
  React.ComponentProps<typeof PopupMenu>,
  'children' | 'onOutside'
> & {
  tasks: Task[];
  onClose: () => void;
};

export const PrioritySubMenu: React.FC<PrioritySubMenuProps> = ({
  tasks,
  onClose,
  ...rest
}) => {
  const { submit: updateTasks } = useUpdateTasks();

  const onPriority = (priority: TaskPriorityOptions | null) =>
    updateTasks(tasks.map((task) => ({ ...task, priority })));

  return (
    <PriorityPickerMenu {...rest} onClose={onClose} onChange={onPriority} />
  );
};
